var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 22.5c-.828 0-1.5-.674-1.5-1.501H7.5a3.004 3.004 0 003 3.001c1.654 0 3-1.346 3-3.001H12c0 .827-.672 1.501-1.5 1.501zm9.815-6.806c-1.31-1.248-2.313-2.554-2.313-6.98 0-3.73-2.971-6.773-6.752-7.141V.75a.75.75 0 10-1.5 0v.823c-3.78.368-6.752 3.41-6.752 7.141 0 4.426-1.002 5.732-2.313 6.98a2.182 2.182 0 00-.527 2.402A2.237 2.237 0 002.25 19.5h16.5c.93 0 1.752-.552 2.093-1.405a2.181 2.181 0 00-.528-2.4zM18.75 18H2.25c-.667 0-1-.772-.53-1.22 1.634-1.555 2.778-3.296 2.778-8.065C4.498 5.556 7.183 3 10.5 3c3.317 0 6.002 2.556 6.002 5.714 0 4.75 1.135 6.502 2.779 8.066.471.45.133 1.22-.53 1.22z",
    fill: "#C4C4C4"
  })));
}

export default __webpack_public_path__ + "./fonts/notification.c3abd27008836e1def2f8e808f3d8adb.svg";
export { SvgNotification as ReactComponent };